enum ProjectFeature {
  ShowExternalBillingDialogAfterCheckout = 'showExternalBillingDialogAfterCheckout',
  UseLoginForExternalBilling = 'useLoginForExternalBilling ',
  AllowPluLookupInProductSearch = 'allowPluLookupInProductSearch',
  ShowCigaretteWarnImage = 'showCigaretteWarnImage',
}

export default ProjectFeature;
